import { ApiError } from "@jobenvoy/core";
import Message from "@/components/common/Message";
import { actionProps } from "@/lib/controlAnalytics";
import { NO_SUCH_POSTING } from "@/lib/posting/page";
import { ROUTES } from "@/lib/routes";
import { RESUME_CHECK_COPY } from "@/lib/tools/copy";
import CheckHeading from "./CheckHeading";

/** The page while a posting is read, or when it cannot be: the way on is the plain tool. */
export default function PostingUnread({ error }: { error: unknown }) {
    const missing = error instanceof ApiError && error.status === 404;
    return (
        <div>
            <CheckHeading posting={null} settled />
            {error ? (
                <Message>
                    <p className="m-0">{missing ? NO_SUCH_POSTING : "Try again in a moment."}</p>
                    <a
                        {...actionProps("navigation_clicked", {
                            source: "ResumeCheck",
                            target: ROUTES.RESUME_CHECK,
                        })}
                        href={ROUTES.RESUME_CHECK}
                        className="mt-2 inline-block font-semibold text-brand-ink"
                    >
                        Check against a job you paste
                    </a>
                </Message>
            ) : (
                <Message>Reading the posting…</Message>
            )}
            <p className="m-0 mt-4 text-ui text-fg-muted">{RESUME_CHECK_COPY.tailorLine}</p>
        </div>
    );
}
